module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.7733/img/business-types/nonprofit-education.png"